import store from '~/js/store'
import { loadMessages } from '~/js/plugins/i18n'

export default async (to, from, next) => {
  await loadMessages(store.getters['lang/locale'])

  next()
}
